export { getCookieValue, deleteCookie, RandomPasswordGenerator } from "ndr-designsystem"

export const TITLE_BASE = "Redispatch 2.0"